module.exports = __webpack_public_path__ + "img/avatar7.ce6ff269.png";